import type { ParameterDefinitionCreateOperation } from '@festina/configuration-general-types/configuration'
import { assertNotEmpty, notEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { type ComponentProps, useMemo } from 'react'

import { AddFieldPlaceholderInput } from '../../../components/addFieldPlaceholderInput/AddFieldPlaceholderInput'
import { useParameterContext } from '../../../context/parameterContext'
import { useOperationsContext } from '../../../workspace/operationsContext'

export const ParameterAddDimensionPlaceholderNameCell = () => {
  const translate = useTranslate()
  const { parameterDefinitionOperation } = useParameterContext()
  const { onAddOrUpdateOperation } = useOperationsContext()

  assertNotEmpty(parameterDefinitionOperation?.internalOperation.entity)

  const dimensionNames = useMemo(() => {
    assertNotEmpty(parameterDefinitionOperation?.internalOperation.entity)

    return (
      parameterDefinitionOperation?.internalOperation.entity
        .dimensionDefinitions ?? []
    )
      .map((dimension) => dimension?.name)
      .filter(notEmpty)
  }, [parameterDefinitionOperation.internalOperation.entity])

  const handleSave: ComponentProps<
    typeof AddFieldPlaceholderInput
  >['onSave'] = async ({ createdValue, layer, block }) => {
    const nextParameterDefinitionCreateOperations = {
      ...parameterDefinitionOperation.internalOperation,
      entity: {
        _type: 'ParameterDefinitionInOut',
        ...parameterDefinitionOperation.internalOperation.entity,
        dimensionDefinitions: [
          ...(parameterDefinitionOperation.internalOperation.entity
            ?.dimensionDefinitions ?? []),
          {
            name: createdValue,
            _type: 'ParameterDimensionDefinitionInOut',
            isRange: false,
          },
        ],
      },
    } satisfies ParameterDefinitionCreateOperation

    await onAddOrUpdateOperation({
      operation: nextParameterDefinitionCreateOperations,
      layer,
      block,
      // Irrelevant, you can only add a dimension to a draft, which can only exist in the workspace.
      shouldOpenUnifiedBranchWorkspace: false,
    })
  }

  return (
    <AddFieldPlaceholderInput
      label={translate('parameterViewer.addDimension.label')}
      description={translate('parameterViewer.addDimension.description')}
      currentValues={dimensionNames}
      onSave={handleSave}
    />
  )
}
